import type { Translations } from '../types';

const translations: Translations = {
  // Login Page
  'login.welcome': 'ברוכים הבאים',
  'login.welcomeSubtitle': 'לוריא דנאור - ניהול שעות',
  'login.selectUserType': 'בחרו את סוג המשתמש שלכם',
  'login.iAmContractor': 'אני קבלן',
  'login.iAmEmployee': 'אני עובד',
  'login.adminLogin': 'כניסת מנהל',
  'login.needHelp': 'צריכים עזרה? פנו למנהל המערכת',
  'login.contractorLogin': 'כניסת קבלן',
  'login.employeeLogin': 'כניסת עובד',
  'login.adminLoginTitle': 'כניסת מנהל',
  'login.back': '→ חזרה',
  'login.vatNumber': 'מספר עוסק מורשה (ח.פ)',
  'login.vatNumberPlaceholder': '123456789',
  'login.vatNumberHint': '9 ספרות',
  'login.password': 'סיסמה',
  'login.passwordPlaceholder': 'ספרות בלבד',
  'login.passwordHint': '4–20 ספרות',
  'login.passwordRequired': 'נדרשת סיסמה להתחברות',
  'login.passportNumber': 'מספר דרכון',
  'login.passportNumberPlaceholder': 'FA3576455',
  'login.passportNumberHint': '5-9 תווים (אותיות וספרות)',
  'login.passcode': 'קוד גישה',
  'login.passcodePlaceholder': '••••',
  'login.submit': 'כניסה',
  'login.connecting': 'מתחבר...',
  'login.error.wrongPasscode': 'קוד גישה שגוי',
  'login.error.vatNotFound': 'מספר עוסק מורשה לא נמצא',
  'login.error.passportNotFound': 'מספר דרכון לא נמצא',
  'login.termsAgreement': 'בהתחברות הנך מסכים עם תנאי השימוש ומדיניות הפרטיות שלנו',
  'login.termsOfUse': 'תנאי השימוש',
  'login.privacyPolicy': 'מדיניות הפרטיות',
  // Employee Dashboard
  'employee.employeeInterface': 'ממשק עובד',
  'employee.employeeNotFound': 'עובד לא נמצא',
  'employee.support': 'תמיכה',
  'employee.logout': 'התנתק',
  'employee.currentMonth': 'חודש נוכחי',
  'employee.previousMonth': 'חודש קודם',
  'employee.twoMonthsAgo': 'לפני חודשיים',
  'employee.monthsAgo': 'לפני {count} חודשים',
  'employee.backToCurrentMonth': 'לחודש נוכחי',
  'employee.hoursEnteredToday': 'הוזנו עליך שעות היום!',
  'employee.hoursNotEnteredToday': 'לא הוזנו עליך שעות היום...',
  'employee.attendanceCapturedToday': 'הנוכחות שלך נקלטה להיום!',
  'employee.totalHours': 'שעות סה״כ',
  'employee.workDays': 'ימי עבודה',
  'employee.sickDays': 'ימי מחלה',
  'employee.dailyAverage': 'ממוצע יומי',
  'employee.alerts': 'התראות',
  'employee.noAlerts': 'אין התראות חדשות',
  'employee.loadingAlerts': 'טוען התראות...',
  'employee.hoursEnteredOn': 'הוזנו עליך שעות ב-{date}',
  'employee.sickDay': 'יום מחלה',
  'employee.holiday': 'יום חג',
  'employee.hours': 'שעות',
  'employee.note': 'הערה',
  'employee.isThisCorrect': 'זה נכון?',
  'employee.approve': 'אישור',
  'employee.approving': 'מאשר...',
  'employee.dispute': 'ערעור',
  'employee.disputeResolved': '✓ הקבלן אישר את הערעור שלך ועדכן את השעות',
  'employee.disputeRejected': '✗ הקבלן דחה את הערעור שלך',
  'employee.contractorApproved': 'הקבלן אישר את הערעור שלך ועדכן את השעות',
  'employee.contractorRejected': 'הקבלן דחה את הערעור שלך',
  'employee.originalHours': 'שעות שהוזנו במקור',
  'employee.updatedHours': 'שעות מעודכנות',
  'employee.claimedHours': 'שעות שטענת שעבדת',
  'employee.calendar': 'לוח שנה',
  'employee.selectedDayDetails': 'פרטי יום נבחר',
  'employee.total': 'סה״כ',
  'employee.reportIssue': 'דווח על בעיה',
  'employee.error.approvingHours': 'שגיאה באישור השעות',
  'employee.today': 'היום',
  'employee.attendance': 'נוכחות',
  'employee.assignedToContractor': 'אתה משובץ לקבלן:',
  'employee.startingAttendance': 'מתחיל נוכחות...',
  'employee.acquiringLocation': 'מאתרים את המיקום שלך...',
  'employee.clickToStartAttendance': 'לחץ להתחלת נוכחות',
  'employee.stoppingAttendance': 'מסיים נוכחות...',
  'employee.clickToStopAttendance': 'לחץ לסיום נוכחות',
  'employee.doNotExitUntilAttendanceStarted': 'אין לצאת מהאפליקציה עד שהנוכחות הופעלה',
  'employee.doNotExitUntilAttendanceStopped': 'אין לצאת מהאפליקציה עד שהנוכחות הסתיימה',
  'employee.monthly': 'תצוגה חודשית',
  // Employee Guides
  'employeeGuides.back': 'חזרה',
  'employeeGuides.pageTitle': 'מדריכים - ממשק עובד',
  'employeeGuides.fab.openAria': 'פתח מדריכים',
  'employeeGuides.fab.title': 'מדריכים',
  'employeeGuides.hero.title': 'ברוכים הבאים למדריך העובד',
  'employeeGuides.hero.body':
    'המדריך הזה מסביר בצורה פשוטה איך להשתמש באפליקציה מהנייד: הפעלת נוכחות, אישור שעות, טיפול בהתראות, בדיקת יומן חודשי ופניה לתמיכה.',
  'employeeGuides.whatYouCanDo.title': 'מה אפשר לעשות בממשק עובד',
  'employeeGuides.whatYouCanDo.item1': '1. הפעלת וסיום נוכחות: התחלה/סיום עבודה בלחצן אחד עם שעון זמן אמת.',
  'employeeGuides.whatYouCanDo.item2':
    '2. אישור או ערעור שעות: לקבל התראות, לאשר שעות שהוזנו או לפתוח ערעור במקרה של אי התאמה.',
  'employeeGuides.whatYouCanDo.item3': '3. מעקב חודשי: לראות שעות, ימי עבודה, ימי מחלה/חג וממוצע יומי.',
  'employeeGuides.whatYouCanDo.item4': '4. יומן תאריכים: לבחור יום ולראות את פירוט השעות של אותו תאריך.',
  'employeeGuides.whatYouCanDo.item5': '5. תמיכה והגדרות: שינוי שפה, שינוי סיסמה, שליחת פניה וקריאת מסמכי מדיניות.',
  'employeeGuides.steps.title': 'איך עובדים בפועל - שלב אחר שלב',
  'employeeGuides.steps.step1Title': 'שלב 1: התחלת יום עבודה',
  'employeeGuides.steps.step1Body':
    'בדף הראשי לחצו על כפתור הנוכחות הכחול להפעלה. במהלך העבודה תראו שעון זמן רץ.',
  'employeeGuides.steps.step2Title': 'שלב 2: סיום עבודה',
  'employeeGuides.steps.step2Body':
    'בסיום לחצו על כפתור העצירה האדום. המערכת שומרת את שעות הנוכחות ומעבירה לאישור קבלן.',
  'employeeGuides.steps.step3Title': 'שלב 3: טיפול בהתראות',
  'employeeGuides.steps.step3Intro': 'כשמופיעה התראה על שעות, בדקו את הפרטים ובחרו:',
  'employeeGuides.steps.step3Approve': 'אישור - אם השעות נכונות.',
  'employeeGuides.steps.step3Dispute': 'ערעור - אם יש טעות, מזינים את השעות הנכונות.',
  'employeeGuides.steps.step4Title': 'שלב 4: בדיקה חודשית',
  'employeeGuides.steps.step4Body':
    'עברו בין חודשים (עד 6 חודשים אחורה), בדקו סיכומים ובחרו תאריך ביומן לצפייה בפרטי אותו יום.',
  'employeeGuides.steps.step5Title': 'שלב 5: תמיכה והגדרות',
  'employeeGuides.steps.step5Body':
    'במידת הצורך היכנסו לתמיכה: החלפת שפה, שינוי סיסמה, שליחת פניה או דיווח על בעיה.',
  'employeeGuides.areas.title': 'מדריך קצר לכל אזור בממשק',
  'employeeGuides.areas.attendanceTitle': 'נוכחות',
  'employeeGuides.areas.attendanceBody': 'הפעלה/עצירה של נוכחות, שעון רץ בזמן אמת, ובדיקת מצב עבודה נוכחי.',
  'employeeGuides.areas.alertsTitle': 'התראות',
  'employeeGuides.areas.alertsBody': 'אישור שעות, פתיחת ערעור, וצפייה בתשובה אם הערעור אושר או נדחה.',
  'employeeGuides.areas.monthlyTitle': 'יומן חודשי',
  'employeeGuides.areas.monthlyBody': 'בחירת חודש ויום לצפייה בשעות, ימי מחלה/חג והערות שנשמרו.',
  'employeeGuides.areas.supportTitle': 'תמיכה',
  'employeeGuides.areas.supportBody': 'דיווח תקלות, יצירת קשר, החלפת סיסמה, החלפת שפה וקריאת מסמכים.',
  'employeeGuides.coverage.title': 'בדיקת כיסוי מלא - מה המדריך מכסה',
  'employeeGuides.coverage.item1': 'הפעלת נוכחות, עצירת נוכחות, זיהוי מיקום, ואישור שאתם אצל הקבלן המשויך.',
  'employeeGuides.coverage.item2': 'התראות על שעות שהוזנו: אישור או ערעור, כולל מעקב אחר תוצאת הערעור.',
  'employeeGuides.coverage.item3': 'חיווי יומי אם הוזנו שעות היום, כולל מצב שבו השעות הגיעו מנוכחות.',
  'employeeGuides.coverage.item4': 'ניווט חודשים עד 6 חודשים אחורה, צפייה בסטטיסטיקות חודשיות ולוח תאריכים.',
  'employeeGuides.coverage.item5': 'צפייה בפרטי יום נבחר: שעות, סה״כ שעות, הערות, וסימון מחלה/חג.',
  'employeeGuides.coverage.item6': 'דיווח על בעיה, שינוי שפה, שינוי סיסמה, שליחת פניה ותצוגת מסמכי מדיניות.',
  'employeeGuides.faq.title': 'שאלות נפוצות (FAQ)',
  'employeeGuides.faq.q1': 'למה לא רואים כפתור נוכחות?',
  'employeeGuides.faq.a1': 'כפתור הנוכחות מוצג רק בחודש הנוכחי. בחודשים קודמים תראו תצוגת נתונים בלבד.',
  'employeeGuides.faq.q2': 'לחצתי התחלה ולא קרה כלום - מה לבדוק?',
  'employeeGuides.faq.a2':
    'בדקו שהשימוש הוא מתוך האפליקציה (לא דפדפן), שהרשאת מיקום מאושרת ושיש חיבור רשת.',
  'employeeGuides.faq.q3': 'אפשר להתחיל/לעצור נוכחות מהדפדפן?',
  'employeeGuides.faq.a3': 'לא. פעולת נוכחות זמינה רק באפליקציה המותקנת.',
  'employeeGuides.faq.q4': 'מה ההבדל בין אישור שעות לערעור?',
  'employeeGuides.faq.a4':
    'אישור מאשר שהרשומה נכונה. ערעור נשלח כשיש טעות בשעות, עם השעות הנכונות לפי מה שעבדתם.',
  'employeeGuides.faq.q5': 'איפה רואים אם הערעור התקבל?',
  'employeeGuides.faq.a5': 'בדף ההתראות יופיע עדכון אם הערעור תוקן או נדחה.',
  'employeeGuides.faq.q6': 'למה יש ימים בצבעים שונים ביומן?',
  'employeeGuides.faq.a6': 'ירוק = יום עבודה, צהוב = מחלה, אדום = חג. בלחיצה על יום רואים פירוט מלא.',
  'employeeGuides.faq.q7': 'כמה חודשים אחורה אפשר לבדוק?',
  'employeeGuides.faq.a7': 'אפשר לעבור עד 6 חודשים אחורה.',
  'employeeGuides.faq.q8': 'איך מחליפים שפה או סיסמה?',
  'employeeGuides.faq.a8': 'נכנסים למסך התמיכה מהאייקון למעלה. שם אפשר לשנות שפה ולשנות סיסמה.',
  'employeeGuides.faq.q9': 'יש טעות בנתונים - למי פונים?',
  'employeeGuides.faq.a9': 'לחצו על "דווח על בעיה" או שלחו פניה במסך התמיכה עם תאריך ותיאור קצר.',
  'employeeGuides.faq.q10': 'מה זה אזהרת "לא אושר על ידי קבלן"?',
  'employeeGuides.faq.a10': 'זו רשומת נוכחות שהועברה לקבלן ועדיין ממתינה לאישורו.',
  'employeeGuides.faq.q11': 'אם אני לא עובד אצל הקבלן שמופיע, מה עושים?',
  'employeeGuides.faq.a11': 'בעת הפעלת נוכחות בחרו דחייה, והודיעו לקבלן שיש לעדכן את השיבוץ.',
  'employeeGuides.tip.main':
    'טיפ חשוב: לפני סיום יום עבודה, ודאו שעצרתם נוכחות. אחרי זה בדקו בהתראות שהשעות נשלחו ואשרו/ערערו לפי הצורך.',
  'employeeGuides.tip.location': 'נוכחות דורשת הרשאת מיקום פעילה באפליקציה.',
  'employeeGuides.tip.language': 'ניתן להחליף שפה בכל רגע דרך מסך התמיכה.',
  // Employee Support Page
  'support.changeLanguage': 'שינוי שפה',
  'support.selectLanguage': 'בחר שפה',
  'support.welcome': 'ברוכים הבאים למרכז התמיכה',
  'support.welcomeTitle': 'תמיכה ועזרה',
  'support.welcomeDescription': 'כאן תוכל למצוא עזרה ותמיכה בשימוש במערכת, ליצור קשר עם צוות התמיכה ולקרוא את מדיניות השימוש והפרטיות.',
  'support.backToHome': 'חזרה לדף הבית',
  'support.contact': 'יצירת קשר',
  'support.contactDescription': 'צריכים עזרה? אנחנו כאן בשבילכם! ניתן ליצור קשר בדרכים הבאות:',
  'support.email': 'דואר אלקטרוני',
  'support.phone': 'טלפון',
  'support.sendInquiry': 'שלח פניה',
  'support.inquiryType': 'סוג הפניה',
  'support.technicalIssue': 'בעיה טכנית',
  'support.technicalIssueDesc': 'תקלות במערכת, שגיאות, בעיות כניסה',
  'support.hoursIssue': 'בעיה בשעות',
  'support.hoursIssueDesc': 'טעויות בחישוב, צורך בתיקון שעות',
  'support.otherIssue': 'אחר',
  'support.otherIssueDesc': 'בעיות נוספות',
  'support.inquiryDescription': 'תיאור הפניה',
  'support.inquiryDescriptionPlaceholder': 'תאר את הבעיה או הפניה שלך בפירוט...',
  'support.submit': 'שלח פניה',
  'support.submitting': 'שולח...',
  'support.submitInquiry': 'שלח פניה',
  'support.error.enterDescription': 'נא להזין תיאור הפניה',
  'support.error.submitError': 'שגיאה בשליחת הפניה. נסה שוב.',
  'support.success.sent': 'הפניה נשלחה בהצלחה! נחזור אליך בהקדם.',
  'support.userGuide': 'מדריך למשתמש',
  'support.howToUse': 'איך להשתמש במערכת?',
  'support.login': '1. התחברות למערכת',
  'support.loginDesc': 'היכנס למערכת באמצעות פרטי הכניסה שנמסרו לך. במקרה של בעיית כניסה, צור קשר עם התמיכה.',
  'support.viewHours': '2. צפייה בשעות העבודה שלך',
  'support.viewHoursDesc': 'בדף הבית תוכל לראות את כל שעות העבודה שהוזנו עליך, כולל סטטיסטיקות חודשיות. השתמש בלוח השנה כדי לראות את השעות לפי תאריכים.',
  'support.approveHours': '3. אישור שעות',
  'support.approveHoursDesc': 'כאשר הקבלן מזין שעות עבורך, תקבל התראה. תוכל לאשר את השעות אם הן נכונות, או לערער אם יש טעות.',
  'support.disputeHours': '4. ערעור על שעות',
  'support.disputeHoursDesc': 'אם השעות שהוזנו עליך אינן נכונות, תוכל לערער ולהזין את השעות הנכונות. הקבלן יקבל את הערעור ויוכל לאשר או לדחות אותו.',
  'support.navigateMonths': '5. ניווט בין חודשים',
  'support.navigateMonthsDesc': 'השתמש בחצים בראש העמוד כדי לעבור בין חודשים שונים. ניתן לצפות בנתונים מ-6 חודשים אחורה.',
  'support.reportProblem': '6. דיווח על בעיות',
  'support.reportProblemDesc': 'במידה ומצאת טעות או בעיה, לחץ על כפתור "דווח על בעיה" בתחתית הדף או שלח פניה דרך מרכז התמיכה.',
  'support.privacyPolicy': 'מדיניות פרטיות',
  'support.privacyPolicyDesc': 'אנו מחויבים לשמור על פרטיות המידע שלך. מדיניות פרטיות זו מסבירה כיצד אנו אוספים, משתמשים ומגנים על המידע האישי שלך.',
  'support.dataCollection': 'איסוף מידע',
  'support.dataCollectionDesc': 'אנו אוספים מידע אישי שאתה מספק לנו במהלך השימוש במערכת, כולל פרטי כניסה, רשומות שעות עבודה ופניות לתמיכה שלנו.',
  'support.dataUsage': 'שימוש במידע',
  'support.dataUsageDesc': 'המידע משמש אך ורק לצורך ניהול שעות העבודה שלך, יצירת דוחות ותמיכה טכנית. לא נשתף במידע שלך עם צדדים שלישיים ללא הסכמתך.',
  'support.dataSecurity': 'אבטחת מידע',
  'support.dataSecurityDesc': 'אנו משתמשים באמצעי אבטחה מתקדמים כדי להגן על המידע שלך, כולל הצפנה, גישה מוגבלת וגיבויים תקופתיים.',
  'support.userRights': 'זכויותיך',
  'support.userRightsDesc': 'יש לך זכות לגשת למידע שלך, לבקש תיקונים או מחיקה. ליצירת קשר בנושאים הקשורים לפרטיות, השתמש בפרטי הקשר למעלה.',
  'support.termsOfService': 'תנאי שימוש',
  'support.termsOfServiceDesc': 'השימוש במערכת זו כפוף לתנאים הבאים. על ידי שימוש במערכת, אתה מסכים לתנאים אלו.',
  'support.authorizedUse': 'שימוש מורשה',
  'support.authorizedUseDesc': 'המערכת מיועדת לשימוש אישי לצורך צפייה ואישור שעות עבודה בלבד. אסור להשתמש במערכת למטרות בלתי חוקיות או לא מורשות.',
  'support.userResponsibility': 'אחריות המשתמש',
  'support.userResponsibilityDesc': 'אתה אחראי לשמור על סודיות פרטי הכניסה שלך ולדווח על כל שימוש לא מורשה בחשבון שלך. אתה אחראי לדיוק המידע שאתה מאשר במערכת.',
  'support.systemAvailability': 'זמינות המערכת',
  'support.systemAvailabilityDesc': 'אנו עושים כמיטב יכולתנו לשמור על זמינות המערכת, אך לא ניתן להבטיח שהמערכת תהיה זמינה תמיד. אנו שומרים לעצמנו את הזכות לבצע תחזוקה ועדכונים.',
  'support.termsChanges': 'שינויים בתנאים',
  'support.termsChangesDesc': 'אנו שומרים לעצמנו את הזכות לעדכן את תנאי השימוש מעת לעת. שינויים יכנסו לתוקף מיד לאחר פרסומם במערכת.',
  'support.liabilityLimitation': 'הגבלת אחריות',
  'support.liabilityLimitationDesc': 'המערכת מסופקת "כמות שהיא". לא נהיה אחראים לנזקים ישירים או עקיפים הנובעים משימוש או אי-שימוש במערכת.',
  'support.copyright': '© 2024 לוריא דנאור. כל הזכויות שמורות.',
  'support.version': 'גרסה 1.0',
  // Dispute Hours Modal
  'dispute.title': 'ערעור על שעות',
  'dispute.date': 'תאריך',
  'dispute.contractorEnteredHours': 'השעות שהוזנו על ידי הקבלן',
  'dispute.whatHoursDidYouWork': 'איזה שעות באמת עבדת ביום זה?',
  'dispute.commonHours': 'שעות נפוצות',
  'dispute.startTime': 'שעת התחלה',
  'dispute.endTime': 'שעת סיום',
  'dispute.cancel': 'ביטול',
  'dispute.submit': 'שלח ערעור',
  'dispute.submitting': 'שולח...',
  'dispute.error.enterTimes': 'נא להזין שעת התחלה וסיום',
  'dispute.error.startBeforeEnd': 'שעת התחלה חייבת להיות לפני שעת הסיום',
  'dispute.error.maxHours': 'מקסימום 14 שעות ביום',
  'dispute.error.sameAsContractor':
    'השעות זהות לשעות שהקבלן הזין — יש להזין שעות שונות כדי לערער',
  'dispute.error.submitError': 'שגיאה בערעור על השעות',
  // Report Issue Modal
  'report.title': 'דיווח על בעיה',
  'report.employeeRelated': 'בעיה הקשורה לעובד',
  'report.issueType': 'סוג הבעיה',
  'report.technicalIssue': 'בעיה טכנית',
  'report.technicalIssueDesc': 'תקלות במערכת, שגיאות, בעיות כניסה',
  'report.hoursIssue': 'בעיה בשעות',
  'report.hoursIssueDesc': 'טעויות בחישוב, צורך בתיקון שעות',
  'report.otherIssue': 'אחר',
  'report.otherIssueDesc': 'בעיות נוספות',
  'report.issueDescription': 'תיאור הבעיה',
  'report.issueDescriptionPlaceholder': 'תאר את הבעיה בפירוט...',
  'report.cancel': 'ביטול',
  'report.submit': 'שלח דיווח',
  'report.submitting': 'שולח...',
  'report.error.enterDescription': 'נא להזין תיאור הבעיה',
  'report.error.submitError': 'שגיאה בשליחת הדיווח. נסה שוב.',
  'report.success.sent': 'הדיווח נשלח בהצלחה! נחזור אליך בהקדם.',
  // Error Boundary
  'error.title': 'משהו השתבש',
  'error.message': 'אנו מתנצלים, אירעה שגיאה בלתי צפויה. נא לרענן את הדף או לחזור לדף הקודם.',
  'error.reload': 'רענן דף',
  'error.goBack': 'חזור',
};

export default translations;
